export default function SkodaFormHeader() {
    return (<header className={`SkodaFormHeader`}>
        <h1>Wizyta w&nbsp;autoryzowanym serwisie&nbsp;Škody</h1>
        <div className="wrapper">
            <h2 className="mb-0">Umów już&nbsp;dziś!</h2>
            <p className="mt-0">
                Wypełnij poniższe pola i&nbsp;czekaj na&nbsp;telefon od&nbsp;naszego doradcy, który ustali z&nbsp;Tobą wszystkie&nbsp;szczegóły.
            </p>
        </div>
    </header>);
}
